// Difficulty modes. Cosmetic/labeling only — boss balance lives in
// src/data/bossComps.ts (per act, per difficulty).

export type Difficulty = "normal" | "hard" | "impossible";

export interface DifficultyConfig {
  /** Player-facing label. */
  label: string;
  /** Theme: which CSS class the map / journey overlay should adopt. */
  themeClass: "" | "impossible-map" | "impossible-map impossible-extreme";
  /** Treated as "harder than normal" for any boolean visual cue. */
  isHardOrAbove: boolean;
}

export const DIFFICULTY_CONFIG: Record<Difficulty, DifficultyConfig> = {
  normal: {
    label: "NORMAL",
    themeClass: "",
    isHardOrAbove: false,
  },
  hard: {
    label: "HARD",
    themeClass: "impossible-map",
    isHardOrAbove: true,
  },
  impossible: {
    label: "IMPOSSIBLE",
    themeClass: "impossible-map impossible-extreme",
    isHardOrAbove: true,
  },
};

export function getDifficultyConfig(d: Difficulty): DifficultyConfig {
  return DIFFICULTY_CONFIG[d] ?? DIFFICULTY_CONFIG.normal;
}
